import fetch from '@/plugin/axios'

// 新增关键字
export function addVeriOrder (data) {
  return fetch({
    url: '/api/order/verification-orders/add',
    method: 'Post',
    data: data
  })
}

// 关键字列表
export function getVeriOrderList (data) {
  return fetch({
    url: '/api/order/verification-orders/list',
    method: 'Post',
    data: data
  })
}

// 删除关键字
export function removeVeriOrder (id) {
  return fetch({
    url: `/api/order/verification-orders/${id}`,
    method: 'Delete'
  })
}

// 关键字信息
export function getVeriOrderInfo (id) {
  return fetch({
    url: `/api/order/verification-orders/info/${id}`,
    method: 'Get'
  })
}

// 修改关键字
export function updateVeriOrder (id, data) {
  return fetch({
    url: `/api/order/verification-orders/${id}`,
    method: 'Put',
    data: data
  })
}

// 回复内容选项
export function getVeriOrderOption (data) {
  return fetch({
    url: '/api/order/verification-orders/base/options',
    method: 'Post',
    data: data
  })
}

// 记录列表
export function getVeriOrderRecordList (data) {
  return fetch({
    url: '/api/order/verification-qr-code/list',
    method: 'Post',
    data: data
  })
}
